import { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDownload } from "../hooks/useDownload";
import { saveAs } from "file-saver";
import moment from "moment";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CampoSelectModal = ({
  isVisible,
  onClose,
  camposOptions,
  values,
}) => {
  const { downloadExcel } = useDownload();
  const [selectedCampos, setSelectedCampos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    onClose();
    setSelectedCampos([]);
  };

  const handleDownloadDiarioClick = async () => {
    if (selectedCampos.length === 0) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await downloadExcel(
        values.fecha,
        selectedCampos,
        "",
        "diario"
      );
      saveAs(
        response,
        `PROGRAMA DEL DÍA ${moment(values.fecha).format("YYYY-MM-DD")}.xlsx`
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
      console.log(error);
    } finally {
      setSelectedCampos([]);
      setIsLoading(false);
      onClose();
    }
  };

  const campoSelectChangeHandler = (e) => {
    const arr = Array.from(e.target.selectedOptions);
    setSelectedCampos(arr.map((item) => Number(item.value)));
  };

  return (
    <Modal isOpen={isVisible} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Campos</ModalHeader>
      <ModalBody>
        <div>
          <select
            multiple
            className="form-control"
            onChange={campoSelectChangeHandler}
            value={selectedCampos}
          >
            {camposOptions.map((item) => (
              <option key={item.id_campo} value={item.id_campo}>
                {item.campo}
              </option>
            ))}
          </select>
          <br />
          <button
            className="btn btn-success"
            onClick={handleDownloadDiarioClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <label>
                <FontAwesomeIcon icon="fas fa-spinner" spin /> Descargar
              </label>
            ) : (
              "Descargar"
            )}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
